
import MuiAlert from '@material-ui/lab/Alert'

function Alert(props) {
    return <MuiAlert elevation={3} variant="filled" {...props} />
}
const bkp = JSON.parse(localStorage.getItem('bkp off'));
async function Alertas() {


    return (
        <div >
            <Alert
                severity="error"
                style={{ width: '50%', marginLeft: '25%' }}
            >
                A empresa {bkp.empresa} precisa de atençao no servidor {bkp.servidor}
            </Alert>
        </div>
    )
}
export default Alertas 
